import { PinValidationStatus } from "./PinPad";

export function isResultOk(validationResult?: PinValidationStatus): boolean {
    return (
        !validationResult ||
        ["PIN_OK", "PIN_VERIFIED"].includes(validationResult)
    );
}

export function preValidatePin(pin: string): PinValidationStatus | undefined {
    if (!/^[0-9]{4}$/.test(pin)) {
        return "PIN_LENGTH_ERROR";
    } else if (isPinSameCharacter(pin) || isPinSequence(pin)) {
        return "PIN_TOO_SIMPLE";
    }
}

function isPinSameCharacter(pin: string) {
    return pin.match(`^${pin[0]}+$`) !== null;
}

function isPinSequence(pin: string) {
    const pinNumbers = Array.from(pin).map(c => parseInt(c, 10));
    if (pinNumbers.length < 2) {
        return false;
    }
    // we are using line equation to check sequence
    // y = ax + b
    const a =
        (pinNumbers[0] - pinNumbers[pinNumbers.length - 1]) /
        (-pinNumbers.length + 1);
    if (Math.abs(a) !== 1) {
        return false;
    }
    const b = pinNumbers[0];
    return pinNumbers.find((value, i) => a * i + b !== value) === undefined;
}
